import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const MainButton = styled(Button)(({ theme }) => ({
  borderRadius: '50px',
  color: 'white',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  [theme.breakpoints.down('xl')]: {
    height: '75px',
    width: '280px',
    fontSize: '1.5rem',
  },
  [theme.breakpoints.up('xl')]: {
    height: '93px',
    width: '347px',
    fontSize: '1.875rem',
  },
}));

const SecondaryButton = styled(Button)(({ theme }) => ({
  borderRadius: '50px',
  color: 'white',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  [theme.breakpoints.down('xl')]: {
    height: '48px',
    width: '180px',
    fontSize: '1.2rem',
  },
  [theme.breakpoints.up('xl')]: {
    height: '67px',
    width: '250px',
    fontSize: '1.5rem',
  },
}));

export const EloSecondaryButton = styled(SecondaryButton)(() => ({
  backgroundColor: '#9464FC',
  '&:hover': {
    backgroundColor: '#7650c9',
  },
}));
